import { TemplatePage } from './types';

const live_streaming_makeup_theme: TemplatePage = {
  header: {
    color: '#F5F6FA',
    icon: 'images/video-templates/beauty-care.jpg',
    title: 'Live Stream Templates — Makeup Theme',
    title_meta: 'Free Live Stream Overlay Templates — Makeup Theme',
    description_meta:
      'Upscale your live streaming with Wave.video’s customizable' +
      ' makeup-themed overlay templates.',
    description:
      'Upscale your live streaming with our collection of customizable makeup-themed overlay templates.' +
      ' Create branded overlays, thumbnails, intros & outros, and lower thirds for your live streams with minimum effort'
  },
  footer: {
    category: 'Live Stream Makeup Theme',
    description:
      'Wave.video’s collection of editable templates for different industries and occasions will help you easily' +
      ' create pro-looking and polished live streams. Engage your online audience with eye-catching branded' +
      ' intros, outros, thumbnails, overlays, and lower thirds without spending a fortune on high-cost video editors.' +
      ' Take your live streaming to the next level and immediately reap the rewards of your efforts!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Makeup Theme',
      search: { name: 'MakeupTheme', tags: 'MakeupTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_makeup_theme;
